export default __webpack_public_path__ + "static/media/img1.7e66d275.PNG";